import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import Calculator from './Calculator'
import FocusterGifSlide from './FocusterGifSlide'

// eslint-disable-next-line
$(() => {
  const resizer = require('iframe-resizer')
  resizer.iframeResizer({
    checkOrigin: false,
    heightCalculationMethod: 'max',
    messageCallback: message => {
      if (message.message === 'signup') {
        window.location = 'https://next.focuster.com/'
      }
    }
  })
})

ReactGA.initialize('UA-55771007-3')
ReactGA.pageview(window.location.pathname)

function signUpClicked() {
  ReactGA.event({
    category: 'Navigation',
    action: 'Sign up button pressed'
  })
}

ReactDOM.render(
  <a href="https://next.focuster.com" onClick={signUpClicked}>
    SIGN IN
  </a>,
  document.getElementById('signup')
)
ReactDOM.render(<Calculator />, document.getElementById('calculator'))

ReactDOM.render(
  <FocusterGifSlide
    id={'fgif2'}
    className={'slide__img img-responsive'}
    gif={'./img/slide2.gif'}
    still={'./img/slide2.png'}
    inverted={false}
    title={'Never Lose Focus with Instant Calendar Rescheduling'}
    content={
      'Updating tasks in your calendar isn’t just tedious. It costs you focus. With automated calendar rescheduling, your priorities are instantly updated for you. Smart reminders keep you focused throughout the day, and a constantly up-to-date calendar means you can easily check what needs to be done next.'
    }
  />,
  document.getElementById('slideimg2')
)

ReactDOM.render(
  <FocusterGifSlide
    id={'fgif3'}
    className={'slide__img img-responsive'}
    gif={'./img/slide3.gif'}
    still={'./img/slide3.png'}
    inverted={true}
    title={'Visualize Progress, Accomplish Goals'}
    content={
      'The key to hitting your goals? Knowing how much you can realistically achieve in a day. The Activity Bar lets you see your day in a glance. See the tasks you’ve completed, the ones that need doing, and the time left to achieve them. Receive a prompt when you’ve overloaded your schedule to help eliminate overwhelm and consistently hit your targets.'
    }
  />,
  document.getElementById('slideimg3')
)



// WEBPACK FOOTER //
// ./src/index.js